import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ComponentPalette = ({ components, onAddComponent }) => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', label: 'All' },
    { id: 'data', label: 'Data' },
    { id: 'charts', label: 'Charts' },
    { id: 'metrics', label: 'Metrics' },
    { id: 'content', label: 'Content' },
    { id: 'compliance', label: 'Compliance' },
  ];

  const filteredComponents =
    selectedCategory === 'all'
      ? components
      : components?.filter((c) => c?.category === selectedCategory);

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h2 className="text-xl font-semibold text-foreground mb-4">Component Library</h2>
      
      <div className="flex flex-wrap gap-2 mb-4">
        {categories?.map((category) => (
          <button
            key={category?.id}
            onClick={() => setSelectedCategory(category?.id)}
            className={`px-3 py-1 rounded-lg text-sm font-medium transition-colors ${
              selectedCategory === category?.id
                ? 'bg-primary text-primary-foreground'
                : 'bg-muted text-foreground hover:bg-muted/80'
            }`}
          >
            {category?.label}
          </button>
        ))}
      </div>

      <div className="space-y-2">
        {filteredComponents?.map((component) => (
          <div
            key={component?.id}
            className="p-3 border border-border rounded-lg hover:border-primary/50 cursor-pointer transition-all group"
            onClick={() => onAddComponent?.(component)}
          >
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name={component?.icon} size={20} color="var(--color-primary)" />
              </div>
              <div className="flex-1">
                <h3 className="text-sm font-semibold text-foreground mb-1">{component?.name}</h3>
                <p className="text-xs text-muted-foreground">{component?.description}</p>
              </div>
              <Icon
                name="Plus"
                size={16}
                className="opacity-0 group-hover:opacity-100 transition-opacity"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ComponentPalette;